import Cookies from 'universal-cookie';

const cookies = new Cookies();

export const initialState = {
  isLoggedIn: JSON.parse(localStorage.getItem("isLoggedIn")) || false,
  user: JSON.parse(localStorage.getItem("user")) || null,
  client_id: process.env.REACT_APP_CLIENT_ID || "Iv1.d214843fe5b03671",
  redirect_uri: process.env.REACT_APP_REDIRECT_URI || "http://localhost:3000/login/",
  branches_url: process.env.REACT_APP_BRANCES_URL || "http://localhost:8000/github/branches/",
  permission: "ADMIN"
};



export const reducer = (state, action) => {
  switch (action.type) {
    case "LOGIN": {
      const expiration = Date.now() + 1000*60*60*7;
      cookies.set("code",action.payload.code,{path:"/"});
      cookies.set("login",action.payload.user.data.user.login,{path:"/"});
      cookies.set("domain",action.payload.user.data.user.login,{ path:"/"});
      cookies.set("name",action.payload.user.name,{ path:"/"})
      return {
        ...state,
        isLoggedIn: action.payload.isLoggedIn,
        user: action.payload.user
      };
    }
    case "LOGOUT": {
      localStorage.clear()
      cookies.set("isLoggedIn",false)
      return {
        ...state,
        isLoggedIn: false,
        user: null
      };
    }
    default:
      return state;
  }
};
